export default __webpack_public_path__ + "static/media/rating_1.9476b9f5.png";